export class XmlRoot {
    cfdf: CoreFunctionCallDescriptions;

    constructor(cfdf: CoreFunctionCallDescriptions) {
        this.cfdf = cfdf;
    }
}

export class CoreFunctionCallDescriptions {
    function_call_description: CoreFunctionCallDescription[];

    constructor() {
        this.function_call_description = [];
    }

    add_function_call(f: CoreFunctionCallDescription) {
        this.function_call_description.push(f);
        return this;
    }
}

export class CoreFunctionCallDescription {
    function_name: string;
    parameter: Array<string|number>;

    constructor(function_name: string) {
        this.function_name = function_name;
        this.parameter = [];
    }

    add_parameter(param: string | number) {
        this.parameter.push(param);
        return this;
    }
}
